import { FaUserCircle, FaBell, FaSignOutAlt } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutUserAsync } from "../data/redux/features/auth/authSlice";

const Navbar = () => {
  const navigate = useNavigate();
  const dispach = useDispatch();
  const refresh_token = localStorage.getItem("refresh_token");
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark px-4">
      <span className="navbar-brand mb-0 h5 d-flex align-items-center">
        📊 SP-admin
      </span>

      <div className="ms-auto d-flex align-items-center gap-3">
        {/* Notification Icon */}
        <FaBell
          size={20}
          className="text-white cursor-pointer"
          title="Notifications"
        />

        {/* User Icon with name */}
        <div className="d-flex align-items-center text-white">
          <FaUserCircle size={22} className="me-2" />
          <span>Pushkar</span>
        </div>

        {/* Logout Button */}
        <button
          className="btn btn-outline-light btn-sm d-flex align-items-center gap-2"
          onClick={() => {
            localStorage.setItem("token", null);
            localStorage.setItem("refresh_token", null);
            dispach(logoutUserAsync({ refresh_token: refresh_token }));
            navigate("/login");
          }}
        >
          <FaSignOutAlt />
          Logout
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
